<template>
  <v-dialog
    v-model="show"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card :color="dark" class="" @drop.prevent="drop">
      <input type="file" id="browse" ref="files" multiple name="browse" @change="handleFilesUpload()" style="display: none" >
      <v-card-title class=""  >
        <span v-if="files.length !== 0">Upload files</span>
        <v-spacer></v-spacer>
        <v-btn color="blue" large v-if="files.length !== 0" @click="upload()">Add Files</v-btn>
        <v-divider class="mx-5" vertical v-if="files.length !== 0"></v-divider>
        <v-btn
          icon
          tile
          :color="modalColor"
          @click="modalOff(false)"
          class="mr-15"
        >
          <v-icon large>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-spacer></v-spacer>
      <v-card-text v-if="files.length === 0">
        <v-row class="mt-10">
          <v-col cols="3"></v-col>
          <v-col cols="6">
            <div class="text-center">
              <v-icon large color="blue">
                mdi-arrange-bring-forward
              </v-icon>

              <h3 class="mt-5">Drag & Drop your files here</h3>

              <!-- <p class="text-body-1">
                Do not share personal information such as your Name, Address,
                Educational Institution, Phone Number, etc. Simply provide all
                assignment instructions and the due date.
              </p> -->

              <v-row no-gutters class="mx-auto">
                <v-col class="ml-10 mr-5">
                  <v-divider class="mt-10  mb-5"></v-divider>
                </v-col>
                <v-col cols="1" class="mt-7 ">
                  OR
                </v-col>
                <v-col class="mr-10 ml-5">
                  <v-divider class="mt-10  mb-7"></v-divider>
                </v-col>
              </v-row>

              <v-btn
                large
                width="200px"
                rounded
                color="blue"
                @click="upload()"
              >
                Browse </v-btn
              >
            </div>
          </v-col>
          <v-col cols="3"></v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-else>
        <v-alert
          :type="actionClass"
          class="mr-15"
          v-if="message"
          dismissible
        >
          {{ message }}
        </v-alert>
        <div class="" v-for="(file, key) in files" :key="key">
          <!-- <v-list two-line :color="dark" class="pa-0 ma-0" >
            <v-list-item >
              <v-list-item-icon>
                <v-icon large class="mt-4">
                  mdi-note
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ file.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ formatByte(file.size) }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-progress-linear
                color="white"
                indeterminate
                rounded
                height="6"
                style="width:100px"
                v-if="!uploaded"
              ></v-progress-linear>

              <v-list-item-action>
                <v-list-item-icon class="mr-15" >
                  <v-btn icon tile outlined :color="modalColor" class="rounded-lg" @click="removeFile(key)">
                    <i class="far fa-trash-alt white--text"></i>
                  </v-btn>
                </v-list-item-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list> -->
          
          <FileUploadComponent :file="file" :upload_type="upload_type" @delete="removeFile(key)" />
          <v-divider class="mt-n5 ml-5 mr-15 pa-0"></v-divider>
        </div>
        <div class="text-center mt-15">
          <v-btn  :color="primaryBlue" class="rounded-lg" large @click="modalOff(true)" :loading="loading" dark> Proceed</v-btn>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="dialog2"
      max-width="500px"
    >
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="confirmSelect" >
      <v-card light>
        <v-card-title>
          Select upload Type
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert
            :type="actionClass"
            class="mr-15"
            v-if="message"
            dismissible
          >
            {{ message }}
          </v-alert>
          <v-radio-group v-model="upload_type" :rules="[v => !!v || 'Upload type is required']">
            <v-radio
              v-for="(item, index) in items"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="rounded-lg" width="150px" type="submit" :color="primaryBlue" large :loading="loading" dark> Continue </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
      
    </v-dialog>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations} from 'vuex';
import colorMxn from "@/mixins/colorMxn";
import validationMxn from "@/mixins/validation_mixin"
import generalMxn from '@/mixins/general_mixin';

export default {
  name: "UploadModal",
  components: {
    FileUploadComponent: () => import ('@/components/fileUploadComponent'),
  },
  props: ["show"],
  mixins: [colorMxn, validationMxn, generalMxn],
  data() {
    return {
      dialog2: false,
      after: true,
      uploaded: true,
      files: [],
      loading: false,
      actionClass: 'success',
      message: '',
      upload_type: 'draft',
      valid: false,
      items: [
        {
          label: 'Draft',
          value: 'draft'
        },
        {
          label: 'Revision',
          value: 'revision'
        },
        {
          label: 'Final',
          value: 'final'
        },
      ]
    };
  },
  computed: {
    ...mapGetters(['getUploadFile']),
  },
  watch: {
    getUploadFile(val) {
      this.files = val
    },
    show(val) {
      setTimeout(() => {
        this.dialog2 = val;
      }, 500);
      
    }
  },
  mounted() {
    this.files = this.getUploadFile;
  },
  methods: {
    ...mapMutations(['setUploadFile','setUploadedFile', 'setUploadedAnswer', 'setUnsetUpload', 'setRemoveFile', 'setRemoveUploadedFile', ]),
    removeFile(key) {
      this.setRemoveFile(key);
    },
    confirmSelect() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.dialog2 = false;
    },
    modalOff(val) {
      const files = [];
      this.message = '';
      this.setUnsetUpload(files)
      this.$emit('close', val);
    },
    upload(){
      document.getElementById('browse').click();
    },
    handleFilesUpload() {
      let uploadedFiles = this.$refs.files.files;
      this.setUploadFile(uploadedFiles);
      this.files = this.getUploadFile;
    },
    async submitFiles() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      const formData = new FormData()

      formData.append('order_id', this.$route.params.id);
      formData.append('upload_type', this.upload_type);
      for( var i = 0; i < this.files.length; i++ ){
        let file = this.files[i];
        formData.append('files[' + i + ']', file);
      }

      const fullPayload = {
        params: formData,
        endpoint: '/upload'
      }

      const response = await this.uploadImage(fullPayload);
      this.actionClass = response.status === "success" ? 'success': "error";
      this.message = response.message;
      if (response.status === "success" ) {
        switch (this.$route.name) {
          case 'customerDraft':
            this.setUploadedFile(response.data);
            break;
          default:
            this.setUploadedAnswer(response.data);
            break;
        }
        this.dialog2=false;
        this.modalOff();
      }
      this.loading = false;

    },
  }
};
</script>
